import { isEmpty } from 'lodash';
import turf from '@turf/turf';

const MAPS_TYPE = 'leafletMap';
const PRECISION = 15;

/**
 * Gets the geometry from the event fired (edition) and saves it to database.
 *
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after creating a geometry.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 */

const editGeometryMaps = ({ event, getCurrentMapState }) => {
  const { defineGeometryActive, itemType, setAtlasGeometry } = getCurrentMapState();

  if (!isEmpty(event.layers.getLayers())) {
    const layer = event.layers.getLayers()[0];
    const editedGeometryLayer = layer.toGeoJSON(PRECISION);
    event.layers.clearLayers([0]);

    if (editedGeometryLayer.geometry.type === 'Polygon') {
      const area = turf.area(editedGeometryLayer) / 10000;
      layer.bindPopup(`${Math.round((area + Number.EPSILON) * 100) / 100} ha`).openPopup();
    }
    if (editedGeometryLayer.geometry.type === 'LineString') {
      const distance = turf.length(editedGeometryLayer, { units: 'kilometers' });
      layer.bindPopup(`${Math.round((distance + Number.EPSILON) * 100) / 100} km`).openPopup();
    }
    if (itemType === MAPS_TYPE && defineGeometryActive) {
      setAtlasGeometry({});
    }
  }
};

export default editGeometryMaps;
